import { Group } from "@mantine/core"
import { SuperAdminTalentTabs } from "src/components/superadmin/talent/SuperAdminTalentTabs"
import { EditSuperAdminTalentAction } from "src/components/superadmin/talent/SuperAdminTalentActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { SuperAdminTalentView } from "src/components/superadmin/talent/SuperAdminTalentView"

export function SuperAdminTalent() {

    const { currentItem } = useAppState(state=>state.users)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.id}`}
                    renderAction={
                        <Group gap="sm">
                            <EditSuperAdminTalentAction />
                        </Group>
                    }
                />
            }
        >
            <SuperAdminTalentTabs/>
            <SuperAdminTalentView/>
        </PageLayout>
    )

}